module.exports = __webpack_public_path__ + "static/SocialDrop-3-light-39f6cf802e7e5b3348c6f531feb51dde.svg";